import { useDispatch, useSelector } from 'react-redux';

import { DriverFuelType, setAvailableFuelType } from '../driverAnalysisReducer';
import { getAvailableFuelType } from '../driverAnalysisSelectors';

export default function useAvailableFuelType() {
    const dispatch = useDispatch();
    return {
        availableFuelType: useSelector(getAvailableFuelType),
        setAvailableFuelType: (fuelType: DriverFuelType) =>
            dispatch(setAvailableFuelType(fuelType)),
    };
}
